import React, { useState } from "react";
import CCrud from "../../components/molecules/crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";

import { Box } from "@chakra-ui/react";
import { toast } from "react-toastify";

import { getCitiesRequest } from "../../services/modules/cities/cities";
import {
  createSubspecialtyRequest,
  deleteSubspecialtyRequest,
  getSubspecialtiesRequest,
  updateSubspecialtyRequest,
} from "../../services/modules/specialty/subspecialty";
import { getSpecialtiesRequest } from "../../services/modules/specialty/specialty";

const Subspecialties = ({ paginationPage }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const type = searchParams.get("type");

  const list = useSelector((state) => state.subspecialties.subspecialties);
  const count = useSelector((state) => state.subspecialties.count);
  const load = useSelector((state) => state.subspecialties.load);
  const specialties = useSelector((state) => state.specialties.specialties);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [page, setPage] = useState(1);
  const [filterObj, setFilterObj] = useState(null);

  const handlePageChange = (page) => {
    setPage(page);
    setFilterObj((prev) => {
      return { ...prev, page_number: page };
    });
  };

  const getList = async (id) => {
    const requestData = {
      params: {
        page_size: 10,
        page_number: 1,
        keyword: "",
        sort_by: "id",
      },
      id,
    };
    dispatch(getSubspecialtiesRequest(requestData));
  };

  // mappedData use for create custom cell to concat multi values or navigate button
  const mappedData = list?.map((data, index) => {
    return {
      ...data,
    };
  });

  const rowData = (data) => {
    setSelectedRow(data);
  };
  const handelSubmit = (data, formik) => {
    // const { name, nameAr, isFulfillmentCenter, fulfillmentCenter, fees } = data;
    const action = () => {
      searchParams.delete("id");
      searchParams.delete("type");
      navigate("/subspecialty");
      !id && formik?.resetForm();
      toast.success(
        ` ${id ? "Sub specialty" : "New Sub specialty"} has been ${
          id ? "updated" : "created"
        } successfully`
      );
    };
    const requestData = {
      body: {
        ...data,
        specialty_id: data?.specialty_id?.value,
      },
      id: id,
      action,
    };
    if (id) {
      //update call
      delete requestData?.body?.Actions;

      dispatch(updateSubspecialtyRequest(requestData));
    } else {
      //create call
      dispatch(createSubspecialtyRequest(requestData));
    }
  };
  const filterList = [
    {
      type: "select",
      name: "name",
      label: "Specialties",
      onChange: (value) => {
        getList(value?.value);
      },
      options: specialties,
    },
  ];

  //list of actions to be displayed when clicked in the 3 dots
  const actionsList = ({ index, data }) => {
    return [
      {
        condition: () => {
          return true;
        },
        click: () => {
          navigate(`?type=form&id=${data?.id}`);
        },
        text: "Edit",
      },
      {
        condition: () => {
          return true;
        },
        click: () => {
          dispatch(
            deleteSubspecialtyRequest({
              id: data?.id,
            })
          );
        },
        text: "Delete",
      },
    ];
  };
  //if you need more buttons in the header beside the add button
  const headerChildren = <></>;

  //if more modals needed, pass them to the modalComponents as below
  const modalComponents = [];

  // listing all cities
  useEffect(() => {
    dispatch(getSpecialtiesRequest());
  }, []);

  return (
    <Box w="100%">
      <CCrud
        table={{
          list: list,
          listTitle: "Sub specialties",
          createBtnTitle: "New Sub specialties",
          CreateBtnIcon: IoIosAdd,
          createBtnFun: () => navigate("?type=form"),
          columns: [
            { accessor: "id", Header: "#" },
            {
              accessor: "name",
              Header: "Sub specialty name",
              sort: false,
            },
            {
              accessor: "name_ar",
              Header: "Sub specialties Arabic name",
              sort: false,
            },
            { accessor: "Actions", Header: "Actions" },
          ],
          isSearch: false,
          searchInputPlaceholder: "Search by Sub specialties name",
          isChecked: false,
          total_count: count,
          isSort: true,
          setFilterObj,
          className: "organization-table system-configurations-table",
          paginationPage: paginationPage,
          handlePageChange,
          rowData: rowData,
          filterList,
          className: "main-table",
          actionsList, //if you want to add custom actions list
          headerChildren,
          openDeleteModal,
          setOpenDeleteModal,
          // handleDeleteRequest,
        }}
        form={{
          initialValues: !id ? {} : initialValues(selectedRow?.rowData),
          structure: () => structure(specialties, id),
          validationSchema: validationSchema,
          title: id ? "Edit Sub specialties" : "Add Sub specialties",
          submitTitle: id ? "Update" : "Add",
          onSubmit: handelSubmit,
          className: { form: "main-form", actionButton: "main-form-buttons" },
          // formChildren,
        }}
        // DetailsComponent={<Details />} //to send details component diff from the default
        modalComponents={modalComponents}
      />
    </Box>
  );
};

export default Subspecialties;
